import { axios } from '@/utils/request'

/**
 * 查询住院结算统计
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjPage (parameter) {
  return axios({
    url: '/vIhZyjstj/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 住院结算统计列表
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjList (parameter) {
  return axios({
    url: '/vIhZyjstj/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加住院结算统计
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjAdd (parameter) {
  return axios({
    url: '/vIhZyjstj/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑住院结算统计
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjEdit (parameter) {
  return axios({
    url: '/vIhZyjstj/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除住院结算统计
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjDelete (parameter) {
  return axios({
    url: '/vIhZyjstj/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出住院结算统计
 *
 * @author zyy
 * @date 2022-12-29 16:08:36
 */
export function vIhZyjstjExport (parameter) {
  return axios({
    url: '/vIhZyjstj/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
